import { z } from "zod";
/**
 * Branding/White-Label-Konfiguration (App-Konsistenz-Audit gegen TranscriptWebapp, Thema 7):
 * "OrderAnalyzer"/"HanseVision" sind nur der konfigurierbare Auslieferungsstandard, kein fest
 * einprogrammierter Produktbezug. Getrennt von reinen Design-/Theming-Einstellungen (helles/
 * dunkles Farbschema) - Branding ist die Geschäftsidentität (Name/Logo/Markenfarbe/Texte), nicht
 * der visuelle Modus.
 */
const hexColor = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, "Muss eine Hex-Farbe im Format #RRGGBB sein.");
// Data-URL-Bilder (Logo/Favicon) - Format- und Größenbegrenzung server- UND clientseitig geprüft
// (siehe apps/api/src/lib/brandingAssetPolicy.ts), hier nur die grobe Formvalidierung.
const imageDataUrl = z
    .string()
    .regex(/^data:image\/(png|jpeg|webp|svg\+xml|x-icon);base64,/, "Muss ein PNG-, JPEG-, WEBP-, SVG- oder ICO-Bild als Data-URL sein.")
    .max(600_000, "Das Bild ist zu groß (max. ca. 450 KB nach Base64-Kodierung).");
export const brandingSettingsSchema = z.object({
    appName: z.string().trim().min(1).max(100),
    companyName: z.string().trim().max(100).default(""),
    logoDataUrl: imageDataUrl.nullable().default(null),
    faviconDataUrl: imageDataUrl.nullable().default(null),
    brandColor: hexColor,
    inkColor: hexColor,
    loginDescription: z.string().trim().max(500).default(""),
});
// Entspricht 1:1 den bisherigen, fest einprogrammierten Werten aus tailwind.config.ts - der
// unveränderte Auslieferungsstandard, bis ein Administrator ihn unter Administration -> Branding
// anpasst.
export const DEFAULT_BRANDING = {
    appName: "OrderAnalyzer",
    companyName: "HanseVision",
    logoDataUrl: null,
    faviconDataUrl: null,
    brandColor: "#0088c5",
    inkColor: "#173042",
    loginDescription: "Auftrags-, Projekt- und Tätigkeitsanalyse mit KI-gestützter Themenklassifikation.",
};
